import z from "zod";
import { apiKeysId, environmentsId, projectsId } from "../../db_gen";
import { zodName } from "../../utils";

const baseConfig = z.object({
  name: zodName(),
  authorizationConfig: z
    .array(
      z.object({
        projectId: projectsId,
        environmentIds: z.array(environmentsId).optional(),
      }),
    )
    .or(z.literal("WHOLE_ORG")),
});

export const apiKeyCreateUpdateFormSchema = z
  .object({
    name: zodName(),
    access: z.enum(["WHOLE_ORG", "PROJECTS"]),
    projects: z.array(
      z.object({
        projectId: projectsId,
        environmentIds: z.array(environmentsId).optional(),
        environmentSelection: z.enum(["ALL", "SPECIFIC"]).optional(),
      }),
    ),
  })
  .refine(
    (data) => {
      if (data.access === "PROJECTS") {
        return data.projects.length > 0;
      }
      return true;
    },
    {
      message: "At least one project must be selected.",
      path: ["projects"],
    },
  )
  .refine(
    (data) => {
      if (data.access === "PROJECTS") {
        return data.projects.every((project) => {
          if (project.environmentSelection === "SPECIFIC") {
            return project.environmentIds && project.environmentIds.length > 0;
          }
          return true;
        });
      }
      return true;
    },
    {
      message: "At least one environment must be selected if 'Specific' is chosen.",
      path: ["projects"],
    },
  );

export type ApiKeyCreateUpdateFormSchema = z.infer<typeof apiKeyCreateUpdateFormSchema>;

export default {
  create: baseConfig,
  update: baseConfig.extend({
    id: apiKeysId,
  }),
  delete: z.object({
    apiKeyId: apiKeysId,
  }),
};
